import React from 'react'
import humanFormat from 'human-format'
import { StatsItem } from './StatsItem'
import { cloneChildrenWithProps } from '../../../jsCore/utils/reactUtils'

const statsBemModifiers = {
  reads: 'view',
  shares: 'share',
}

function formatNumber(number, opts) {
  return humanFormat(Number(number), opts)
}

function statItemView(stat, modifier, key) {
  const statsItemProps = {
    key,
    modifier,
    children: formatNumber(stat, { decimals: 0 }),
  }
  return <StatsItem {...statsItemProps} />
}

function getStats(stats, modifiers) {
  return Object.entries(stats).map(([statName, stat], index) =>
    statItemView(stat, modifiers[statName], index)
  )
}

export function StatsWrapper({ children }) {
  const blockName = 'stats'
  return (
    <ul className={blockName}>
      {cloneChildrenWithProps(getStats(children, statsBemModifiers), { blockName })}
    </ul>
  )
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/post_metadata/components/StatsWrapper.js